import { render, staticRenderFns } from "./create-a-swot-for-your-business-idea.vue?vue&type=template&id=849f14d4&"
import script from "./create-a-swot-for-your-business-idea.vue?vue&type=script&lang=js&"
export * from "./create-a-swot-for-your-business-idea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports